import React, { forwardRef } from "react";
import { Checkbox as AntdCheckbox, CheckboxRef } from "antd";
import { StyledCheckBox } from "./checkbox.styles";
import { CheckboxProps, CompoundedCheckboxType } from "./checkbox.types";

const InternalCheckbox = forwardRef<CheckboxRef, CheckboxProps>(
    ({ ...rest }, ref) => {
        return <StyledCheckBox ref={ref} {...rest}></StyledCheckBox>;
    }
);

InternalCheckbox.displayName = "InternalCheckbox";

export const Checkbox = InternalCheckbox as CompoundedCheckboxType;
Checkbox.displayName = "Checkbox";
Checkbox.Group = AntdCheckbox.Group;
